module.exports = __webpack_public_path__ + "assets/i18n/nl.json";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/nl.json
// module id = 1210
// module chunks = 0